import equals from 'fast-deep-equal/es6'
import { is } from 'ramda'
import { blocks } from '../blocks-state'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findPathToValue = (valueToFind: any, obj: any, path: (string | number)[] = []): (string | number)[] | null => {
    if (equals(obj, valueToFind)) {
        return path
    }

    if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
            const found = findPathToValue(valueToFind, obj[i], [...path, i])
            if (found) return found
        }
    } else if (is(Object, obj)) {
        for (const key in obj) {
            const found = findPathToValue(valueToFind, obj[key], [...path, key])
            if (found) return found
        }
    }

    return null
}

export const findBlockPathById = (id: string) => {
    const idPath = findPathToValue(id, blocks.value)
    const blockPath = idPath?.slice(0, idPath.length - 1)
    return blockPath
}